import type { ColumnsType } from 'antd/es/table';
import styled from 'styled-components';
import { Colors, Table, IcPlus, IcTrash } from 'basic-ui-lib';
import { ActionProps } from 'basic-ui-lib/components/Table/Table';

interface DataType {
  key: string;
  promotionName: string;
  startDate: string;
  endDate: string;
  scope: string;
  promotion: string;
  status: 'Progress' | 'Expired Date';
  checked?: boolean;
}

const TableBox = styled.div`
  margin-top: 12px;
`;

const Tag = styled.div`
  height: 30px;
  gap: 8px;
  border-radius: 5px;
  padding-top: 4px;
  padding-right: 8px;
  padding-bottom: 4px;
  padding-left: 8px;
  text-align: center;
`;

const TagInProgress = styled(Tag)`
  background-color: ${Colors.primary[1]};
  color: ${Colors.primary[6]};
`;

const TagExpiredDate = styled(Tag)`
  background-color: #e5e6eb;
  color: #232f3e;
`;

const TableStoryBoard = () => {
  const columns: ColumnsType<DataType> = [
    {
      title: 'PROMOTION NAME',
      dataIndex: 'promotionName',
      render: (text) => <span style={{ color: '#1677ff' }}>{text}</span>,
    },
    {
      title: 'START DATE',
      dataIndex: 'startDate',
    },
    {
      title: 'END DATE',
      dataIndex: 'endDate',
    },
    {
      title: 'SCOPE OF APPLICATION',
      dataIndex: 'scope',
    },
    {
      title: 'PROMOTION',
      dataIndex: 'promotion',
    },
    {
      title: 'STATUS',
      dataIndex: 'status',
      render: (status) =>
        status === 'Progress' ? (
          <TagInProgress>In Progress</TagInProgress>
        ) : (
          <TagExpiredDate>Expired Date</TagExpiredDate>
        ),
    },
  ];

  const actions: ActionProps<DataType>[] = [
    {
      label: 'Add Promotion',
      icon: <IcPlus width={16} height={16} />,
      onClick: (item) => {
        console.log('Add Promotion clicked', item.key);
      },
    },
    {
      label: 'Delete Selected',
      icon: <IcTrash width={16} height={16} />,
      onClick: (item) => {
        console.log('Delete Selected clicked', item.key);
      },
    },
  ];

  return (
    <TableBox>
      <Table<DataType>
        className='custom-table'
        columns={columns}
        dataSource={data.slice(0, 10)}
        scroll={{ x: 'max-content' }}
        pagination={false}
        actions={actions}
      />
    </TableBox>
  );
};

export default TableStoryBoard;

const promotionNames = [
  '$0 Delivery Fee',
  'Free Item with Purchase',
  'Spend More, Save More',
  'Buy 1 get 1 free',
  'BOGOF',
  'Straight Discount',
  'Combo',
  'Percent off',
  'GIFT',
  'Save on Menu Items',
  'Happy Hour Special',
  'Weekend Deal',
  'Flash Sale',
  'Member Exclusive',
  'Holiday Special',
];

const scopes = ['Apply by product', 'All products', 'Selected categories', 'Member only'];
const promotionValues = ['10%', '20%', '30%', '15%', '$10.00 OFF', '$20.00 OFF', '$5.00 OFF', '$15.00 OFF'];
const statuses = ['Progress', 'Expired Date'];

const generateRandomDate = (start: Date, end: Date): string => {
  const date = new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime()));
  return (
    date.toLocaleDateString('en-US', {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric',
    }) + ' 09:00'
  );
};

const data: DataType[] = Array.from({ length: 100 }, (_, index) => {
  const startDate = generateRandomDate(new Date(2024, 0, 1), new Date(2024, 11, 31));
  const endDate = generateRandomDate(new Date(2024, 11, 31), new Date(2025, 11, 31));

  return {
    key: (index + 1).toString(),
    promotionName: promotionNames[Math.floor(Math.random() * promotionNames.length)],
    startDate,
    endDate,
    scope: scopes[Math.floor(Math.random() * scopes.length)],
    promotion: promotionValues[Math.floor(Math.random() * promotionValues.length)],
    status: statuses[Math.floor(Math.random() * statuses.length)] as 'Progress' | 'Expired Date',
  };
});
